export default __webpack_public_path__ + "static/media/email.3179d70b.svg";